module.exports = __webpack_public_path__ + "static/heliskiingreisen-793b1538a31571c73d7db928f4e52df0.svg";